export default __webpack_public_path__ + "static/media/facebook.d2229b74.svg";